import React from 'react';
import {Oval} from '../../pages/players/styles';

const getFatigueZoneBullet = (status: string, tooltip?: any) => {
  switch (status) {
    case 'zone 1':
      if(tooltip){
        return <Oval size={'8'} color={'watch'} margin={'0px 0px 0px 3px'} onMouseOver={(event) => tooltip[0](event, tooltip[1])} onMouseOut={tooltip && tooltip[2]}/>;
      }
      return <Oval size={'8'} color={'watch'} margin={'0px 0px 0px 3px'}/>;

    case 'zone 2':
      if(tooltip){
        return <Oval size={'8'} color={'warning'} margin={'0px 0px 0px 3px'} onMouseOver={(event) => tooltip[0](event, tooltip[1])} onMouseOut={tooltip && tooltip[2]}/>;
      }
      return <Oval size={'8'} color={'warning'} margin={'0px 0px 0px 3px'} />;

    case 'zone 3':
      if(tooltip){
        return <Oval size={'8'} color={'medical'} margin={'0px 0px 0px 3px'} onMouseOver={(event) => tooltip[0](event, tooltip[1])} onMouseOut={tooltip && tooltip[2]} />;
      }
      return <Oval size={'8'} color={'medical'} margin={'0px 0px 0px 3px'} />;

    default:
      return;
  }
};

export default getFatigueZoneBullet;
